<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Interconsultas</h4>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de interconsultas"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Interconsultas">
  <AyudaInterconsulta />
</Modal>

    <hr>

    <!-- DataTable -->
    <DataTable
      :data="interconsultas"
      :columns="columnas"
      idField="idInterconsulta"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarEditar="false"
      :mostrarVer="true"
      :mostrarEliminar="false"
      mensajeVacio="No hay interconsultas disponibles."
      @refresh="getDataPaginaTodos()"
      @info="row => abrirModalEditar(row.idInterconsulta)"
      @view="row => abrirEditar(row.idAtencion, row.idInterconsulta)"
    >
      <!-- Celda: Fecha -->
      <template #cell-fechaReg="{ row }">
        {{ getFormattedDate(row.fechaReg) }}
      </template>

      <!-- Celda: Estado con color -->
      <template #cell-estadoInter="{ row }">
        <span class="badge-estado" :class="getClassForEstadoInter(row.estadoInter)">
          {{ row.estadoInter }}
        </span>
      </template>

      <template #acciones-fila="{ row }">
        <select class="form-select form-select-sm"
                @change="handleAction($event, row.idAtencion, row.idInterconsulta)"
                @click.stop>
          <option disabled selected>Seleccione...</option>
          <option value="resumen">Resumen</option>
          <option value="detalles">Edición/Detalles</option>
        </select>
      </template>
    </DataTable>

    <!-- Modal resumen interconsulta -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalInterconsultaLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalInterconsultaLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row mb-2" v-for="campo in camposModal" :key="campo.label">
              <div class="col-3">
                <label class="fw-bold">{{ campo.label }}</label>
              </div>
              <div class="col-9">
                <span class="form-control-plaintext"
                      :style="campo.upper ? 'text-transform:uppercase' : ''">
                  {{ campo.valor }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout             from '@/components/Layout.vue'
import Footer             from '@/components/Footer.vue'
import AyudaInterconsulta from '@/views/ayuda/AyudaInterconsulta.vue'
import DataTable          from '@/components/DataTable.vue'
import dateFormat         from '@/modules/dateFormat.js'
import api                from '@/services/api'
import { openModal }      from '@/modules/modalHelper.js'

export default {
  name: 'Interconsultas',
  components: { Layout, Footer, AyudaInterconsulta, DataTable },

  data() {
    return {
      interconsultas:   [],
      datoInterconsulta:{},
      titulo:           '',
      modalWindow:      true,
      showModalHelp:    false,
      p_idMedico:       0,

      // Columnas para DataTable
      columnas: [
        { field: 'fechaReg',      label: 'Fecha Reg.' },
        { field: 'estadoInter',   label: 'Estado' },
        { field: 'medicoAtencion',label: 'Médico' },
        { field: 'paciente',      label: 'Paciente' },
      ],
    }
  },

  computed: {
    camposModal() {
      const d = this.datoInterconsulta
      return [
        { label: 'Id. Interconsulta', valor: d.idInterconsulta },
        { label: 'Fecha Atención',    valor: this.getFormattedDate(d.atencionFechaReg) },
        { label: 'Estado',            valor: d.estadoInter },
        { label: 'Médico',            valor: d.medicoAtencion },
        { label: 'Motivo',            valor: d.motivo,  upper: true },
        { label: 'Cuadro',            valor: d.cuadro,  upper: true },
      ]
    }
  },

  mounted() {
    this.p_idMedico = window.sessionStorage.getItem('idMedico')
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.getDataPaginaTodos()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    // Carga de datos
    getDataPaginaTodos() {
      if (!this.p_idMedico) return
      api.get(`/vwinterconsultas/idmedico/${this.p_idMedico}`)
        .then(response => { this.interconsultas = response.data.reverse() })
        .catch(error   => console.error('Error al obtener interconsultas:', error))
    },

    // Acciones del select por fila
    handleAction(event, idAtencion, idInterconsulta) {
      const action = event.target.value
      if      (action === 'resumen')  this.abrirModalEditar(idInterconsulta)
      else if (action === 'detalles') this.abrirEditar(idAtencion, idInterconsulta)
      event.target.value = 'Seleccione...'
    },

    abrirModalEditar(idInterconsulta) {
      this.modalWindow = true
      if (idInterconsulta) {
        api.get(`/vwinterconsultas/destino/${idInterconsulta}`)
          .then(resp => { this.datoInterconsulta = resp.data })
      }
      openModal('ventanaModal')
      this.titulo = 'Resumen de la Interconsulta'
    },

    abrirEditar(idAtencion, idInterconsulta) {
      if (idInterconsulta) {
        this.$router.push(`/interconsultadestinoform/${idAtencion}/${idInterconsulta}`)
      }
    },

    getClassForEstadoInter(estado) {
      return {
        'SOLICITADA': 'solicitada',
        'ASIGNADA':   'asignada',
        'PROCESO':    'proceso',
        'RECHAZADA':  'rechazada',
        'FINALIZADA': 'finalizada',
      }[estado] || ''
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<style>
.busqueda-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
}

.busqueda-campo {
  display: flex;
  flex-direction: column;
  min-width: 130px;
  flex: 1;
}
.busqueda-campo--lg { flex: 3 1 260px; }

.busqueda-bar .form-label {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 3px;
  color: #6c757d;
}

.btn-icono {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  padding: 6px 12px;
  flex-shrink: 0;
}

.btn-label { font-size: 14px; }

@media (max-width: 576px) {
  .busqueda-campo,
  .busqueda-campo--lg { flex: 1 1 100%; }
  .btn-icono { width: 100%; }
}
</style>